import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import appState from '../../state/AppStateContainer';
import { ServiceSupplier } from '../../services/service-supplier';
import { PrequalificationDecision } from '../../util/appEnum';

export const useInboxCount = (): number | undefined => {
  useEffect(() => {
    const appFetchesCountAtStartUp = appState.isAdminRole() && appState.isPurchasingActive();
    if (appFetchesCountAtStartUp || appState.getSupplierApplicationCount() !== undefined) return;
    ServiceSupplier.fetchSupplier({ mini: true, prequalification: PrequalificationDecision.INBOX })
      .then(({ inboxCount }: { inboxCount: number }) =>
        appState.setSupplierApplicationCount(inboxCount),
      )
      .catch(error => Sentry.captureException(error));
  }, []);

  return appState.getSupplierApplicationCount();
};
